/**
 * Copilot journey — protocol `transact-pilot` (ADR-0159 §3).
 *
 * Discovery via bingbot (the documented Bing crawler UA that grounds
 * Copilot web answers) → honest note: Copilot commerce is fed by
 * Microsoft product feeds / ads; Copilot Actions browsing is
 * unidentifiable (standard Edge / Chromium UA, observed).
 *
 * Like the Perplexity `transact-pilot` shape, no fake mandate / cart /
 * pay phases — the terminal phase names the feed-driven pilot honestly.
 */

import { buildDiscoveryPhase, buildReadMenuPhase } from './discovery.js';
import type { JourneyContext, Phase } from './types.js';

export function buildCopilotJourney(ctx: JourneyContext): Phase[] {
  const { agent, live, installed, cardUrl, catalogUrl, liveProducts } = ctx;
  return [
    buildDiscoveryPhase(agent, installed, cardUrl, live.card),
    buildReadMenuPhase(agent, installed, catalogUrl, live.catalog, liveProducts),
    // ── Terminal transact-pilot phase — feed-driven, no signed mandate ──
    {
      id: 'pilot',
      name: 'Transact (pilot)',
      tier: 'illustration',
      narration:
        `Documented by vendor: Copilot Checkout is fed by Microsoft product feeds, not a signed rail — and its browsing sub-agent uses a stock Edge UA, unidentifiable without a signature.`,
      endpoint: {
        method: 'POST',
        path: '(vendor pilot rail)',
        status: 200,
        ms: 0,
        body: '{ "rail": "microsoft.copilot-checkout", "grounding": "product-feeds" }',
        live: false,
      },
      ok: true,
    },
  ];
}
